<template>
  <g :style="{
    transform: `translate(0px, ${y}px)`
  }">
    <rect rx="5" :width="width" :height="height" fill="#E6E7E8" />
    <rect rx="5" :width="50" :height="height" fill="#39AFAB" />
    
    <!-- <text  :x="53" :y="height/2" alignment-baseline="baseline" text-anchor="end" fill="white" xml:space="preserve" style="white-space: pre" font-weight="bold" font-family="Poppins, Helvetica neue, Helvetica" font-size="14" letter-spacing="0em">
        {{ points | localString }}
    </text> -->
    <text :x="50" :y="height/2 + 2" alignment-baseline="hanging" text-anchor="end" fill="white" xml:space="preserve" style="white-space: pre" font-family="Poppins, Helvetica neue, Helvetica" font-size="9" letter-spacing="0em">
        points 
        <!-- TODO: to support scans or points -->
    </text>

    <text  :x="46" :y="height/2 + 5" alignment-baseline="hanging" text-anchor="start" fill="grey" xml:space="preserve" style="white-space: pre" font-family="Poppins, Helvetica neue, Helvetica" font-size="8" letter-spacing="0em">
        {{ rank.subtitle}}
    </text>
  </g>
</template>

<script>
import * as d3plus from 'd3plus-text'
export default {
  props:['x','y','width', 'height', 'rank' ],
  computed:{
    points(){
      return this.rank.point || 0
    },
    labels(){
      return [
        { 
          text: this.rank.label, 
          fontSize: 12,
          fontMax: 12,
          fontWeight: 'bold',
          width: this.width - 60,
          height: this.height/2 + 3,
          x: 60,
          y: 2,
          verticalAlign: 'bottom',
          align: 'start',
          color: '#000000'
        },
        { 
          text: parseInt(this.points).toLocaleString(),
          fontSize: 16,
          fontMax: 16,
          fontWeight: 'bold',
          width: 43,
          height: (this.height/2) + 4 ,
          x: 2,
          y: 0,
          verticalAlign: 'bottom',
          align: 'end',
          color: '#FFFFFF'
        },
      ]
    }
  },
  methods:{
    displayLabels(){
      new d3plus.TextBox()
        .select(this.$el)
        .data(this.labels)
        .fontSize(d => d.fontSize)
        .fontMax(d => d.fontMax)
        .fontMin(2)
        .fontWeight('bold')
        .width(d => d.width)
        .height(d => d.height)
        .x(d => d.x)
        .y(d => d.y)
        .textAnchor(d => d.align)
        .verticalAlign(d => d.verticalAlign)
        .fontResize(true)
        .fontColor(d => d.color)
        .render()
    },
    
  },
  mounted(){
    this.displayLabels()
  },
  filters:{
    localString(v){
      return parseInt(v).toLocaleString()
    }
  }
}
</script>